enum BusinessRuleCategory {
  ComboConversion = 'item_substitution',
  DefaultSizeSelection = 'default_size_selection',
  ComboSizeTransformation = 'combo_size_propagation',
  ALaCarteConversion = 'a_la_carte_conversion',
}
enum BusinessRuleOption {
  ConvertToCombo = 'front_end_substitute_item',
  SelectDefaultSize = 'select_default_size',
  TransformComboSize = 'propagate_combo_size',
  ConvertToALaCarte = 'convert_to_a_la_carte',
}
enum MenuModuleErrorType {
  unmatchedItems = 'unmatched_items',
  unavailableItems = 'unavailable_items',
}
enum UnavailabilityReason {
  outOfStock = 'out_of_stock',
  notSold = 'not_sold',
}
enum EntityType {
  item = 'item',
  constraint = 'constraint',
}

export {
  BusinessRuleOption,
  BusinessRuleCategory,
  MenuModuleErrorType,
  UnavailabilityReason,
  EntityType,
};
